<template>
  <section :id="id" class="scroll-m-[180px]">
    <header
      class="mb-8 flex items-start gap-4"
      :class="{
        'justify-between': align === undefined,
        'justify-center': align === 'center',
      }"
    >
      <div>
        <component
          :is="titleWrapper"
          v-if="title || $slots.title"
          class="group"
          :to="to"
        >
          <component
            :is="titleDefinition.tag"
            class="text-balance text-xl font-extrabold sm:text-2xl"
            :class="{ 'font-title': newHomeEnabled }"
          >
            <slot name="title">
              {{ titleDefinition.text }}
            </slot>

            <slot name="append-title" />

            <app-icon
              v-if="to"
              class="ml-2 scale-90 transition group-hover:scale-100"
              icon="ph:arrow-circle-up-right"
            />
          </component>
        </component>

        <component
          :is="subtitleDefinition.tag"
          v-if="subtitle"
          class="text-subtle mt-1"
        >
          {{ subtitleDefinition.text }}
        </component>
      </div>

      <div v-if="$slots['append-header']" class="mt-1">
        <slot name="append-header" />
      </div>
    </header>

    <slot />

    <div
      v-if="$slots.append"
      class="mt-8 flex justify-center [&>[data-app-button]:only-child]:w-full sm:[&>[data-app-button]:only-child]:w-auto"
    >
      <slot name="append" />
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { I18nMessage } from "@pollen/core/model/i18n.model";

import type { RouteLocationRaw } from "#vue-router";

const properties = defineProps<{
  title?:
    | I18nMessage
    | { tag: `h${1 | 2 | 3 | 4 | 5 | 6}` | string; text?: I18nMessage };
  subtitle?:
    | I18nMessage
    | { tag: `h${1 | 2 | 3 | 4 | 5 | 6}` | string; text?: I18nMessage };
  id?: string;
  to?: RouteLocationRaw;
  align?: "center";
}>();

const titleWrapper = computed(() =>
  properties.to ? resolveComponent("nuxt-link") : "div",
);

const titleDefinition = computed(() => {
  if (typeof properties.title === "object") return properties.title;

  return {
    tag: "h2",
    text: properties.title,
  };
});

const subtitleDefinition = computed(() => {
  if (typeof properties.subtitle === "object") return properties.subtitle;

  return {
    tag: "p",
    text: properties.subtitle,
  };
});

const newHomeEnabled = useFeatureFlag("new_home");
</script>
